const URL_BASE=process.env.REACT_APP_API;

export const URL_COVERS=`${URL_BASE}/content/covers/list`;
//export const URL_EDIT_PACKS=`${URL_BASE}/content/packs/edit`;
